import React from "react"

import PopoverMenuSeparator from "../../../../../gd-components/popover-menu/popover-menu/popover-menu-separator"
import VScroll from "../../../../../gd-components/scrolling/custom-v-scroll/v-scroll"
import {ColorPalette} from "../../../../color-coding/color-coding"

const FIELD_COLORS: any[] = [
    {value: 27, label: 'Dark blue'},
    {value: 20, label: 'Blue'},
    {value: 6,  label: 'Light blue'},
    {value: 28, label: 'Cyan'},
    {value: 9,  label: 'Aquamarine'},
    {value: 29, label: 'Light green'},
    {value: 11, label: 'Green'},
    {value: 30, label: 'Dark green'},
    {value: 31, label: 'Lime'},
    {value: 14, label: 'Yellow'},
    {value: 15, label: 'Orange'},
    {value: 16, label: 'Light red'},
    {value: 32, label: 'Red'},
    {value: 1,  label: 'Raspberry'},
    {value: 33, label: 'Pink'},
    {value: 3,  label: 'Deep pink'},
    {value: 34, label: 'Purple'},
    {value: 35, label: 'Dark purple'},
    {value: 22, label: 'Light violet'},
    {value: 36, label: 'Violet'},
    {value: 19, label: 'Brown'},
    {value: 37, label: 'Mahogany'},
    {value: 38, label: 'Chocolate'},
    {value: 17, label: 'Black'},
]

type Props = {
    options?        : any[] | null
    icon            : string
    color           : number

    canChangeIcon?  : boolean

    onValueChange   : func
}

const debug = false
// const debug = "FieldIconWithColor_PopoverContent"

export default function FieldIconWithColor_PopoverContent(props:Props) {

    debug && console.log(debug, 'render', props.icon, props.color, props.options)

    const onColorSelect = (value:any) => {
        props.onValueChange({
            icon    : props.icon,
            color   : value
        })
    }

    const onIconSelect = (value:any) => {
        props.onValueChange({
            icon    : value,
            color   : props.color
        })
    }

    return (
        <VScroll containerClass="ui5-popover-menu max-h-500">
            <div className="flex-column-left-top">
                <div className="flex-row-left-center ui5-txt-not-important ui5-txt-bold h-36 p-l-10">Change color</div>
                <div className="ui5-popover-selector color-picker w-320 p-t-10">
                    {_.map(FIELD_COLORS, (option:{value:number, label:string})=>
                        <div key        = {option.value}
                             className  = "ui5-color-picker"
                             style      = {{
                                 backgroundColor: gd.skin.colors.mainColor({
                                     colorNumber: option.value,
                                     corePalette: ColorPalette.CORE
                                 })
                             }}
                             onClick    = {()=>onColorSelect(option.value)}/>
                    )}
                </div>
            </div>

            {props.canChangeIcon &&
                <>
                    <PopoverMenuSeparator/>

                    <div className="flex-column-left-top">
                        <div className="flex-row-left-center ui5-txt-not-important ui5-txt-bold h-36 p-l-10">Change icon</div>
                        <div className="ui5-popover-selector icon-selector p-t-0">
                            {_.map(props.options, (group: string[], key: number) =>
                                <div className="icons-group" key={key}>
                                    {_.map(group, (value: string, key: number) => {
                                        const classes = Classes("block", {
                                            selected: value === props.icon
                                        })

                                        return (
                                            <div className={classes} key={key} onClick={() => {
                                                onIconSelect(value)
                                            }}>
                                                <div className={Classes("icon", value)}/>
                                            </div>
                                        )
                                    })}
                                </div>
                            )}
                        </div>
                    </div>
                </>}

        </VScroll>
    )
}

FieldIconWithColor_PopoverContent.defaultProps = {
    canChangeIcon: true
}